<!--FILTER & SEARCH SECTION-->
<div class="row">
    <div class="col-md-8">
    </div>
    <div class="col-md-4">
        <div class="filter-by-name-option">
            <div class="form-group">
                <mat-form-field>
                    <input
                        placeholder="Search by Role Name"
                        matInput
                        [(ngModel)]="searchByName"
                        name="search"
                        #search="ngModel"
                    >
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>
            </div>
        </div>
    </div>
</div>

<!--ROLES LIST SECTION-->
<mat-accordion>
    <mat-expansion-panel
    *ngFor="let role of roleList | searchFilter: ['name']:searchByName"
    class="margin-bottom-20"
    (opened)="panelMap[role?.id] = true"
    (closed)="panelMap[role?.id] = false"
    >
    <mat-expansion-panel-header class="mat-expansion-panel-header--auto">
       <div class="list-item width-stretch">
          <div class="list-item-content">
             <div class="margin-bottom-10">
                <h4>{{ role.name }}</h4>
             </div>
          </div>
          <div class="list-item-action">
             <ng-template [ngIf]="panelMap[role?.id]">
                <button
                   mat-icon-button
                   type="button"
                   (click)="$event.stopPropagation();editRole(role)"
                   >
                <img
                   src="assets/images/Edit.png"
                   alt="Edit"
                   >
                </button>
                <button
                   mat-icon-button
                   type="button"
                   (click)="$event.stopPropagation();openDialog(role)"
                   >
                <img
                   src="assets/images/Delete.png"
                   alt="Delete"
                   >
                </button>
             </ng-template>
          </div>
       </div>
    </mat-expansion-panel-header>
    <div class="stretch user-permission-font-16">
        Has Access To:
        <span class="comma-separated-list">
            <ng-template ngFor let-feature [ngForOf]="role?.feature">
                <span>{{ feature?.fName }}</span>
            </ng-template>
        </span>
    </div>
    </mat-expansion-panel>
    <div class="no-data" *ngIf="(roleList | searchFilter:['name']:searchByName)?.length === 0 ">No data found!!!</div>
 </mat-accordion>